export default __webpack_public_path__ + "static/photo-22-b63685970f439fa654eb6b94dfa1c3a3.jpg";